var map = {
	"./add_music.svg": "9919",
	"./addmusic.svg": "7d0d",
	"./address.svg": "0e25",
	"./ai_make.svg": "3bd8",
	"./amount.svg": "02ba",
	"./card.svg": "2d9e",
	"./details_lang.svg": "2ab4",
	"./details_more.svg": "650a",
	"./details_name.svg": "e83f",
	"./details_style.svg": "827f",
	"./details_type.svg": "cad3",
	"./download.svg": "4dae",
	"./edit.svg": "aa46",
	"./enterprise.svg": "93e1",
	"./icon-music-b.svg": "ff42",
	"./image.svg": "8736",
	"./intro.svg": "7f5a",
	"./key.svg": "e7b0",
	"./legalPerson.svg": "67f9",
	"./link.svg": "18f0",
	"./list_move.svg": "f55f",
	"./lyric.svg": "0603",
	"./name.svg": "0b38",
	"./new-appleMusic.svg": "55c5",
	"./new-qq.svg": "a202",
	"./new-spotify.svg": "b375",
	"./new-wyy.svg": "2c7f",
	"./out.svg": "a673",
	"./pause.svg": "d46e",
	"./pause_white.svg": "a905",
	"./phone.svg": "dd82",
	"./play.svg": "fb4f",
	"./play_white.svg": "4f5b",
	"./relname.svg": "b6a1",
	"./sidebar_card.svg": "6ac2",
	"./sidebar_friend.svg": "b1f3",
	"./sidebar_money.svg": "6865",
	"./sidebar_music.svg": "b721",
	"./sidebar_name.svg": "2565",
	"./sidebar_qiye.svg": "63db",
	"./sidebar_quan.svg": "1146",
	"./sidebar_qushi.svg": "3bf7",
	"./sidebar_setting.svg": "3e16",
	"./sidebar_work.svg": "5227",
	"./time.svg": "3add",
	"./yitixian.svg": "9c23"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";